import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import performRequest from "../../../api/request";

const tableHead = [
  "Sr.",
  "Farm Name",
  "Water cycle name",
  "Type of system",
  "Water source",
  "Schedule Date",
  "Actions",
];
const tableHeadClient = [
  "Sr.",
  "Water cycle name",
  "Type of system",
  "Water source",
  "Schedule Date",
  "Actions",
];

const WaterManagementTable = ({
  data = [],
  currentPage,
  itemsPerPage,
  showArchived,
  onActionComplete,
}) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);

  const archiveCycle = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/waterManagement/updateArchiveStatus/${id}`,
        { archieveData: true }
      );
      if (res.status === 200) {
        onActionComplete();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const restoreCycle = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/waterManagement/updateArchiveStatus/${id}`,
        { archieveData: false }
      );
      if (res.status === 200) {
        onActionComplete();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const goToView = (id) => {
    navigate(`/farm-water-management/view/${id}`);
  };

  function formatDate(dateString) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];

    function getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }

    const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}`;
    return formattedDate;
  }

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {store.Role === process.env.REACT_APP_ROLE_CLIENT
              ? tableHeadClient.map((item, index) => (
                  <th key={index}>{item}</th>
                ))
              : tableHead.map((item, index) => <th key={index}>{item}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            // Correctly accessing the last entry's scheduleDate
            const lastEntryScheduleDate =
              item?.timeLines[item.timeLines.length - 1]?.scheduleDate || null;

            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td>{item?.farmName || "N/A"}</td>
                )}
                <td>{item?.cycleName || "N/A"}</td>
                <td>{item?.typeOfSystem || "N/A"}</td>
                <td>{item?.waterSource || "N/A"}</td>
                <td>
                  {lastEntryScheduleDate
                    ? formatDate(lastEntryScheduleDate)
                    : "N/A"}
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <CustomViewButton onClick={() => goToView(item?.id)} />

                    {!showArchived ? (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => archiveCycle(item.id)}
                      >
                        Archive
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => restoreCycle(item.id)}
                      >
                        Restore
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WaterManagementTable;
